import type { Scheme } from '../scheme.ts'
import { arrl33cmScheme } from './arrl-33cm.ts'
import { lorawanUs915Scheme } from './lorawan-us915.ts'
import { MESHTASTIC_BANDWIDTHS, meshtasticScheme } from './meshtastic.ts'

/** Every built-in, in the order the panel lists them. */
export function builtinSchemes(): Scheme[] {
  return [
    ...[...MESHTASTIC_BANDWIDTHS].reverse().map(meshtasticScheme),
    lorawanUs915Scheme(),
    arrl33cmScheme(),
  ]
}
